import { $$ } from '../../../shared/js/utils/dom';
import { Swiper } from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import { A11y } from './modules/a11y/a11y.mjs';
import merge from 'deepmerge';
import Bus from '../../../shared/js/modules/event-bus';
import { currentBreakpoint } from '../../../shared/js/globals/breakpoints';

// TODO: fix duplication of skiplinks on resize (this.restartSlider and module A11y), add destroySkipLink method

const sliders = $$('.swiper');
const sliderInstances = [];

export class Slider {
  constructor(params) {
    this.el = params.el;
    this.children = this.el.querySelectorAll('.swiper-slide');
    this.config = {
      modules: [A11y, Navigation, Pagination],
      loop: true,
      init: false,
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
        renderFraction: function (currentClass, totalClass) {
          return (
            '<span class="sr-only">Inhalt</span><span class="' +
            currentClass +
            ' slider__pagination-counter-current"></span>&nbsp;' +
            ' <span aria-hidden="true">/</span><span class="sr-only">von</span> ' +
            '&nbsp;<span class="' +
            totalClass +
            ' slider__pagination-counter-total"></span>'
          );
        },
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    };
    this.userConfig = params.userConfig ?? {};
    this.galleryConfig = {
      slidesPerView: 3,
      centeredSlides:
        this.children.length >= this.slidesPerView * 2 ||
        this.children.length === 1,
      loop: this.children.length >= this.slidesPerView * 2,
    };
    this.navTimelineConfig = {
      centeredSlides: true,
      pagination: false,
      initialSlide: this.userConfig.initialSlide ?? 0,
      loop: false,
      slidesPerView: 5,
      // slidesPerView: this.el.clientWidth / this.children[0].clientWidth,
      autoHeight: false,
    };
    this.reducedMotionIsActive = window.matchMedia(
      '(prefers-reduced-motion)'
    ).matches;
    this.isGallery = this.el.dataset.sliderPreset === 'gallery';
    this.isNavTimeline = this.el.dataset.sliderPreset === 'navTimeline';
    this.swiperInstance = undefined;
  }

  init() {
    this.eventBinding();
    this.classBinding();
    this.initSwiper();
  }

  initSwiper() {
    this.updateConfig();
    this.swiperInstance = new Swiper(this.el, {
      ...this.config,
    });
    this.swiperInstance.on('slideChange', () => {
      Bus.broadcast('slider_change', {
        currentIndex: this.swiperInstance.realIndex,
        isGallery: this.isGallery,
        isNavTimeline: this.isNavTimeline,
        activeSlide: this.swiperInstance.slides[this.swiperInstance.realIndex],
      });
    });

    this.swiperInstance.init();
    this.initialWindowWidth = window.innerWidth;
  }

  updateConfig() {
    if (this.reducedMotionIsActive) this.config.loop = false;

    if (this.isGallery) this.config = merge(this.config, this.galleryConfig);
    if (this.isNavTimeline)
      this.config = merge(this.config, this.navTimelineConfig);

    if (
      currentBreakpoint === 'tablet' ||
      currentBreakpoint === 'desktop' ||
      currentBreakpoint === 'bigscreen'
    ) {
      if (this.isGallery) {
        this.config.slidesPerView = this.galleryConfig.slidesPerView;
        this.config.centeredSlides =
          this.children.length >= this.config.slidesPerView * 2 ||
          this.children.length === 1;
        this.config.loop =
          this.children.length >= this.config.slidesPerView * 2;
      }
    }

    if (currentBreakpoint === 'smartphone') {
      if (this.isGallery) {
        this.config.slidesPerView = 1;
        this.config.centeredSlides = false;
        this.config.loop =
          this.children.length >= this.config.slidesPerView * 2;
      }
      if (this.isNavTimeline) {
        this.config.slidesPerView = 1;
        this.config.centeredSlides = false;
      }
    }
  }

  eventBinding() {
    if (this.isGallery || this.isNavTimeline)
      Bus.subscribe(
        'resize',
        'MediaGalleryResize',
        this.onResizeHandler.bind(this)
      );

    if (this.isNavTimeline)
      Bus.subscribe('timeline_select', 'TimelineSelect', obj =>
        this.swiperInstance.slideTo(obj.currentIndex)
      );
  }

  classBinding() {
    this.el.classList.add(`slider--${this.children.length}-items`);
  }

  onResizeHandler() {
    if (this.isGallery) {
      this.restartSlider();
    }
    if (this.isNavTimeline && window.innerWidth !== this.initialWindowWidth) {
      this.restartSlider();
    }
  }

  restartSlider() {
    this.swiperInstance.on('destroy', () => {
      this.initSwiper();
    });
    this.swiperInstance.destroy();
  }
}

sliders.forEach(el => {
  const sliderInstance = new Slider({
    el,
  });

  sliderInstances.push(sliderInstance);
  sliderInstance.init();
});
